export default "__VITE_ASSET__CjkCfG1R__"